// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"104":"9c3a24d5","727":"d090efa3"}[chunkId] + ".css";
};